export default __webpack_public_path__ + "static/media/32_photo.4a9f9510.jpg";